const serviceTypeCategories = Object.freeze({
  ServiceLocation: 1,
  ContractService: 2,
  Specialist: 4,
  AdminProviderCenter: 5,
});

export default serviceTypeCategories;
